import { createTheme } from "@mui/material/styles";
import { lightColors, darkColors } from "./tokens/colors";
import { typography, breakpoints, zIndices, radii, shadows } from "./tokens";

/**
 * Create MUI theme based on mode (light/dark)
 * @param {string} mode - 'light' or 'dark'
 * @returns {object} - MUI theme object
 */
export const createAppTheme = (mode = 'light') => {
  const colors = mode === 'dark' ? darkColors : lightColors;

  return createTheme({
    palette: {
      mode,
      primary: {
        main: colors.palette.primary.main,
        dark: colors.palette.primary.dark,
        light: colors.palette.primary.light,
        contrastText: colors.palette.primary.contrastText,
      },
      secondary: {
        main: colors.palette.secondary.main,
        dark: colors.palette.secondary.dark,
        light: colors.palette.secondary.light,
        contrastText: colors.palette.secondary.contrastText,
      },
      background: {
        default: colors.palette.background.default,
        paper: colors.palette.background.paper,
      },
      text: {
        primary: colors.palette.text.primary,
        secondary: colors.palette.text.secondary,
        disabled: colors.palette.text.disabled,
      },
      status: colors.palette.status,
      grey: colors.palette.grey,
      custom: colors.palette.custom,
      action: {
        hover: mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)',
        selected: mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
      },
    },
    typography: {
      fontFamily: typography.fontFamily,
    },
    breakpoints: breakpoints,
    zIndex: zIndices,
    shape: {
      borderRadius: parseInt(radii.base),
    },
    // We add our named shadows as a custom property so they are accessible via theme.customShadows
    customShadows: shadows,
  });
};

// Export default theme (light mode) for backward compatibility
const theme = createAppTheme('light');
export default theme;
